import { motion } from "framer-motion";
import { WifiMark } from "./WifiMark";

const links = [
    { label: "Collection", href: "#collection" },
    { label: "Manifesto", href: "#manifesto" },
    { label: "Lookbook", href: "#lookbook" },
    { label: "Drop 001", href: "#drop" },
];

export const Navbar = ({ season = "SS26 — Void" }) => {
    const go = (e, href) => {
        e.preventDefault();
        document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
    };
    return (
        <motion.header
            initial={{ y: -80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 1.6, duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="fixed top-0 left-0 right-0 z-[80] mix-blend-difference"
            data-testid="navbar"
        >
            <nav className="flex items-center justify-between px-6 sm:px-12 py-6">
                <a
                    href="#top"
                    onClick={(e) => go(e, "#top")}
                    className="flex items-baseline gap-0 font-display font-semibold text-xl tracking-tight text-white"
                    data-testid="nav-logo"
                >
                    <WifiMark className="h-4 w-auto self-center" pulsing={false} />
                    FFLINE
                </a>
                <div className="hidden md:flex items-center gap-10">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            onClick={(e) => go(e, l.href)}
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                            className="group relative text-[11px] tracking-[0.25em] uppercase text-zinc-300 hover:text-white transition-colors duration-300"
                        >
                            {l.label}
                            <span className="absolute -bottom-1 left-0 h-px w-0 bg-signal transition-[width] duration-300 group-hover:w-full" />
                        </a>
                    ))}
                </div>
                <span className="text-[11px] tracking-[0.25em] uppercase text-zinc-400" data-testid="nav-season">
                    {season}
                </span>
            </nav>
        </motion.header>
    );
};
